import { doc, setDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../../firebase/firebase";

/**
 * Writes progress to:
 * users/{studentUid}/assignments/{packetId}
 */
export async function saveAssignmentProgress({
  studentUid,
  packetId,
  status,
  currentQuestionIndex,
  totalTimeSpentSeconds,
  questionProgress,
  markedQuestionIds = [],
  correct,
  completedAt,
}) {
  if (!studentUid || !packetId) {
    console.error("❌ saveAssignmentProgress aborted", {
      studentUid,
      packetId,
    });
    return false;
  }

  const ref = doc(db, "users", studentUid, "assignments", packetId);

  const payload = {
    status,
    currentQuestionIndex,
    totalTimeSpentSeconds,
    questionProgress,
    markedQuestionIds,
    ...(typeof correct === "number" && { correct }),
    ...(completedAt && { completedAt }),
    lastSavedAt: serverTimestamp(),
  };

  console.log("📍 Writing assignment progress:", {
    path: `users/${studentUid}/assignments/${packetId}`,
    currentQuestionIndex,
    totalTimeSpentSeconds,
    sample: questionProgress?.[Object.keys(questionProgress || {})[0]],
  });

  await setDoc(ref, payload, { merge: true });

  console.log("✅ Firestore write complete");
  return true;
}
